import axios from 'axios';

export default axios.create({
  baseURL: 'https://us1.locationiq.com/v1/'
});
